// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"3059696b","215":"87d4e35a","272":"d5ef586a","274":"4894b53b","345":"8286fa3e","388":"7340e3c4","589":"8beed8cb","831":"145242a2"}[chunkId] + ".chunk.css";
};